/* ═══════════════════════════════════════
   FATAL GLOW — mio-script.js
   Beauty That Burns 🔥 × Shopify API
═══════════════════════════════════════ */

'use strict';

/* ── DOM refs ── */
const navbar        = document.getElementById('navbar');
const hamburger     = document.getElementById('hamburger');
const navCenter     = document.getElementById('navCenter');
const cartTrigger   = document.getElementById('cartTrigger');
const cartSidebar   = document.getElementById('cartSidebar');
const cartOverlay   = document.getElementById('cartOverlay');
const cartClose     = document.getElementById('cartClose');
const cartBadge     = document.getElementById('cartBadge');
const cartList      = document.getElementById('cartList');
const cartEmpty     = document.getElementById('cartEmpty');
const cartTotal     = document.getElementById('cartTotalDisplay');
const checkoutBtn   = document.getElementById('checkoutBtn');
const productGrid   = document.getElementById('productGrid');
const toast         = document.getElementById('toast');
const filterBtns    = document.querySelectorAll('.filter');

/* ══════════════════════════════════════
   NAVBAR: scroll + hamburger
══════════════════════════════════════ */
if (navbar) {
  window.addEventListener('scroll', () => {
    navbar.classList.toggle('scrolled', window.scrollY > 40);
  }, { passive: true });
}

if (hamburger && navCenter) {
  hamburger.addEventListener('click', function(e) {
    e.stopPropagation();
    e.preventDefault();
    hamburger.classList.toggle('open');
    navCenter.classList.toggle('open');
  });

  navCenter.querySelectorAll('a').forEach(link => {
    link.addEventListener('click', () => {
      hamburger.classList.remove('open');
      navCenter.classList.remove('open');
    });
  });

  document.addEventListener('click', (e) => {
    if (!navbar.contains(e.target)) {
      hamburger.classList.remove('open');
      navCenter.classList.remove('open');
    }
  });
}

/* ══════════════════════════════════════
   SCROLL REVEAL
══════════════════════════════════════ */
const revealObserver = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add('in');
      const children = entry.target.querySelectorAll('.product-card.reveal');
      children.forEach((child, i) => {
        setTimeout(() => child.classList.add('in'), i * 100);
      });
    }
  });
}, { threshold: 0.12 });

document.querySelectorAll('.reveal').forEach(el => revealObserver.observe(el));

/* ══════════════════════════════════════
   TOAST
══════════════════════════════════════ */
let toastTimer;
function showToast(message) {
  if (!toast) return;
  toast.textContent = message;
  toast.classList.add('show');
  clearTimeout(toastTimer);
  toastTimer = setTimeout(() => toast.classList.remove('show'), 2800);
}

/* ══════════════════════════════════════
   SHOPIFY CART API
══════════════════════════════════════ */
async function fetchCart() {
  const res = await fetch('/cart.js');
  return res.json();
}

async function shopifyAddToCart(variantId, quantity = 1) {
  const res = await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity })
  });
  return res.json();
}

async function shopifyChangeQty(lineIndex, quantity) {
  const res = await fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ line: lineIndex, quantity })
  });
  return res.json();
}

function formatPrice(cents) {
  return '€' + (cents / 100).toFixed(2).replace('.', ',');
}

/* ══════════════════════════════════════
   CART UI
══════════════════════════════════════ */
async function updateCartUI() {
  const cart = await fetchCart();

  const totalQty = cart.item_count;
  const allBadges = document.querySelectorAll('#cartBadge, #globalCartBadge');
  allBadges.forEach(badge => {
    badge.textContent = totalQty;
    badge.classList.add('pop');
    setTimeout(() => badge.classList.remove('pop'), 320);
  });

  if (cartTotal) {
    cartTotal.textContent = formatPrice(cart.total_price);
  }

  if (!cartList || !cartEmpty) return;
  cartList.innerHTML = '';
  cartEmpty.style.display = cart.items.length === 0 ? 'block' : 'none';

  cart.items.forEach((item, idx) => {
    const li = document.createElement('li');
    li.className = 'cart-item';

    const thumb = item.image
      ? `<img src="${item.image}" alt="${item.title}" style="width:60px;height:80px;object-fit:cover;border:1px solid rgba(255,0,127,.2);">`
      : `<div class="cart-thumb">FG*</div>`;

    const variant = item.variant_title && item.variant_title !== 'Default Title'
      ? `<p style="font-size:.75rem;color:rgba(245,239,239,.5);margin:.2rem 0;">${item.variant_title}</p>`
      : '';

    li.innerHTML = `
      ${thumb}
      <div class="cart-info">
        <p class="cart-iname">${item.title}</p>
        ${variant}
        <p class="cart-iprice">${formatPrice(item.final_line_price)}</p>
        <div class="cart-qty">
          <button onclick="changeQty(${idx + 1}, ${item.quantity - 1})" aria-label="Diminuisci">−</button>
          <span>${item.quantity}</span>
          <button onclick="changeQty(${idx + 1}, ${item.quantity + 1})" aria-label="Aumenta">+</button>
        </div>
      </div>
      <button class="cart-iremove" onclick="changeQty(${idx + 1}, 0)" aria-label="Rimuovi">✕</button>
    `;
    cartList.appendChild(li);
  });
}

window.changeQty = async function(lineIndex, newQty) {
  await shopifyChangeQty(lineIndex, newQty);
  await updateCartUI();
};

/* ══════════════════════════════════════
   CART SIDEBAR TOGGLE
══════════════════════════════════════ */
function toggleCart(forceOpen) {
  if (!cartSidebar || !cartOverlay) return;
  const isOpen = cartSidebar.classList.contains('open');
  const shouldOpen = forceOpen !== undefined ? forceOpen : !isOpen;
  cartSidebar.classList.toggle('open', shouldOpen);
  cartOverlay.classList.toggle('open', shouldOpen);
  document.body.style.overflow = shouldOpen ? 'hidden' : '';
}

if (cartTrigger) cartTrigger.addEventListener('click', () => toggleCart());
if (cartClose)   cartClose.addEventListener('click', () => toggleCart(false));
if (cartOverlay) cartOverlay.addEventListener('click', () => toggleCart(false));
document.addEventListener('keydown', (e) => { if (e.key === 'Escape') toggleCart(false); });

if (checkoutBtn) {
  checkoutBtn.addEventListener('click', async () => {
    const cart = await fetchCart();
    if (cart.item_count === 0) {
      showToast('Il carrello è vuoto! Aggiungi qualcosa 🛒');
      return;
    }
    window.location.href = '/checkout';
  });
}

/* ══════════════════════════════════════
   SIZE MODAL × SHOPIFY VARIANTS
══════════════════════════════════════ */
const sizeOverlay    = document.getElementById('sizeOverlay');
const sizeModal      = document.getElementById('sizeModal');
const sizeModalClose = document.getElementById('sizeModalClose');
const sizeModalName  = document.getElementById('sizeModalName');
const sizeConfirmBtn = document.getElementById('sizeConfirmBtn');
const sizeOptions    = document.getElementById('sizeOptions');

let _selectedVariantId = null;

function openSizeModal(productHandle, productTitle) {
  _selectedVariantId = null;
  if (sizeModalName) sizeModalName.textContent = productTitle;
  if (sizeConfirmBtn) sizeConfirmBtn.disabled = true;
  if (sizeOptions) sizeOptions.innerHTML = '<p style="color:rgba(245,239,239,.5);font-size:.85rem;">Caricamento taglie...</p>';

  if (sizeOverlay) sizeOverlay.classList.add('open');
  if (sizeModal) sizeModal.classList.add('open');
  document.body.style.overflow = 'hidden';

  fetch(`/products/${productHandle}.js`)
    .then(r => r.json())
    .then(product => {
      if (!sizeOptions) return;
      sizeOptions.innerHTML = '';

      product.variants.forEach(variant => {
        const btn = document.createElement('button');
        btn.className = 'size-btn';
        btn.textContent = variant.title === 'Default Title' ? 'Unica' : variant.title;
        btn.dataset.variantId = variant.id;
        btn.disabled = !variant.available;
        if (!variant.available) {
          btn.style.opacity = '0.35';
          btn.style.cursor = 'not-allowed';
        }
        btn.addEventListener('click', () => {
          sizeOptions.querySelectorAll('.size-btn').forEach(b => b.classList.remove('selected'));
          btn.classList.add('selected');
          _selectedVariantId = variant.id;
          if (sizeConfirmBtn) sizeConfirmBtn.disabled = false;
        });
        sizeOptions.appendChild(btn);
      });

      if (product.variants.length === 1) {
        const onlyBtn = sizeOptions.querySelector('.size-btn');
        if (onlyBtn && !onlyBtn.disabled) onlyBtn.click();
      }
    })
    .catch(() => {
      if (sizeOptions) sizeOptions.innerHTML = '<p style="color:#ff4949;">Errore nel caricamento taglie.</p>';
    });
}

function closeSizeModal() {
  if (sizeOverlay) sizeOverlay.classList.remove('open');
  if (sizeModal) sizeModal.classList.remove('open');
  document.body.style.overflow = '';
}

if (sizeModalClose) sizeModalClose.addEventListener('click', closeSizeModal);
if (sizeOverlay) sizeOverlay.addEventListener('click', (e) => {
  if (e.target === sizeOverlay) closeSizeModal();
});
document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeSizeModal(); });

if (sizeConfirmBtn) {
  sizeConfirmBtn.addEventListener('click', async () => {
    if (!_selectedVariantId) return;
    sizeConfirmBtn.disabled = true;
    sizeConfirmBtn.textContent = 'AGGIUNGENDO...';

    try {
      await shopifyAddToCart(_selectedVariantId, 1);
      await updateCartUI();
      showToast('🔥 Aggiunto al carrello!');
      closeSizeModal();
      toggleCart(true);
    } catch (e) {
      showToast('⚠️ Errore — riprova');
    } finally {
      sizeConfirmBtn.disabled = false;
      sizeConfirmBtn.textContent = 'AGGIUNGI AL CARRELLO';
    }
  });
}

window.addToCart = function(handle, title) {
  openSizeModal(handle, title);
};

/* ══════════════════════════════════════
   PRODUCT FILTERS
══════════════════════════════════════ */
if (filterBtns.length && productGrid) {
  filterBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      filterBtns.forEach(b => b.classList.remove('active'));
      btn.classList.add('active');

      const filter = btn.dataset.filter;
      const cards = productGrid.querySelectorAll('.product-card');

      cards.forEach((card, i) => {
        const cat = card.dataset.cat;
        const visible = filter === 'all' || cat === filter;
        card.style.transition = `opacity .35s ease ${i * 40}ms, transform .35s ease ${i * 40}ms`;

        if (visible) {
          card.style.display = '';
          requestAnimationFrame(() => {
            card.style.opacity = '1';
            card.style.transform = '';
          });
        } else {
          card.style.opacity = '0';
          card.style.transform = 'scale(.95)';
          setTimeout(() => {
            if (!btn.classList.contains('active')) return;
            card.style.display = 'none';
          }, 350 + i * 40);
        }
      });
    });
  });
}

/* ══════════════════════════════════════
   SMOOTH ANCHOR con offset navbar
══════════════════════════════════════ */
document.querySelectorAll('a[href^="#"]').forEach(link => {
  link.addEventListener('click', (e) => {
    const href = link.getAttribute('href');
    if (!href || href === '#' || href === '#!') return;
    const target = document.querySelector(href);
    if (!target) return;
    e.preventDefault();
    const navH = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--nav-h')) || 68;
    const top = target.getBoundingClientRect().top + window.scrollY - navH;
    window.scrollTo({ top, behavior: 'smooth' });
  });
});

/* ══════════════════════════════════════
   PARALLAX: hero blobs
══════════════════════════════════════ */
const blob1 = document.querySelector('.blob-1');
const blob2 = document.querySelector('.blob-2');

window.addEventListener('scroll', () => {
  const sy = window.scrollY;
  if (blob1) blob1.style.transform = `translateX(-50%) translateY(${sy * .08}px)`;
  if (blob2) blob2.style.transform = `translateY(${sy * -.06}px)`;
}, { passive: true });

/* ══════════════════════════════════════
   FIX — Immagini You may also like su mobile
══════════════════════════════════════ */
document.addEventListener('DOMContentLoaded', function() {
  const observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        const imgs = entry.target.querySelectorAll('img[loading="lazy"]');
        imgs.forEach(function(img) {
          img.loading = 'eager';
          const src = img.getAttribute('src');
          if (src) img.src = src;
        });
      }
    });
  }, { threshold: 0.1 });

  document.querySelectorAll('.card-gallery').forEach(function(card) {
    observer.observe(card);
  });
});
/* FIX — Testo card Potrebbe piacerti */
document.addEventListener('DOMContentLoaded', function() {
  const observer = new MutationObserver(function() {
    document.querySelectorAll('product-recommendations .product-grid__card').forEach(function(card) {
      card.style.setProperty('--color', '#080808');
      card.style.color = '#080808';
    });
  });
  observer.observe(document.body, { childList: true, subtree: true });
});
/* ══════════════════════════════════════
   INIT
══════════════════════════════════════ */
updateCartUI();
console.log('%c* FATAL GLOW 🔥 beauty that burns *', 'color: #FF007F; font-family: cursive; font-size: 1.2rem;');